/** One file entry from a report collection endpoint (e.g. GET /dispatch-reports). */
export interface ReportFile {
  name: string;
  /** '-' file, 'd' directory, 'l' symlink */
  type: string;
  size: number;
  modified: string;
}

/** A [from, to] range for the combined-range endpoints; each bound is a bare date (YYYY-MM-DD, the whole Sydney day) or an ISO timestamp. */
export interface ReportDateRange {
  from: string;
  to: string;
}

/** The reserved name the backend resolves to the newest file. */
export const LATEST = "latest";
